import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface CloseEventDialog {
  confirmed: boolean;
}

@Component({
  selector: 'app-ventilation-reset-to-default-confirm-modal',
  templateUrl: './ventilation-reset-to-default-confirm-modal.component.html',
  styleUrls: ['./ventilation-reset-to-default-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VentilationResetToDefaultConfirmModalComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<VentilationResetToDefaultConfirmModalComponent>) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('575px');
  }

  onCancel(): void {
    this.dialogRef.close({
      confirmed: false,
    });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
    });
  }
}
